import { render, staticRenderFns } from "./FilterComponent.vue?vue&type=template&id=5bfc6153"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"
import style0 from "./FilterComponent.vue?vue&type=style&index=0&id=5bfc6153&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports